export { getApolloClient, getApollo, initializeApollo } from './lib/client';
export { default as graphQLWrapper } from './lib/withApollo';

export {
    customQueryHook,
    customLazyQueryHook,
    customMutationHook,
    useQuery,
    useLazyQuery,
    useMutation,
    ApolloProvider,
    useApolloClient,
    ApolloError,
    ApolloClient,
    from,
    HttpLink,
    type NormalizedCacheObject,
    InMemoryCache,
    type ApolloQueryResult,
    type DocumentNode,
    type OperationVariables
} from './lib/apolloMigration';
